document.addEventListener("DOMContentLoaded", function() {
  // console.log("working");
  // document.getElementById('PBarNextFrameWrapper')?.remove();
  
  const videoContainers = document.querySelectorAll('.cstm_muti_video_conn');

  let lastVideo = null; // To keep track of the last played video
  let lastVideoBtn = null; // To keep track of the last clicked button

  videoContainers.forEach((videoRapper) => {
    const video = videoRapper.querySelector("video");
    const videoBtn = videoRapper.querySelector(".video_pausebtn");

    video.pause();
    video.controls = false; 
    videoBtn.classList.remove("disable_btn"); 
  
    videoRapper.addEventListener("click", function () {
      if (video.paused) {
     
        video.play().catch(error => {
          console.error('Error playing video:', error);
        });
        video.controls = false; 
        videoBtn.classList.add("disable_btn"); 
     
        if (lastVideo && lastVideo !== video) {
          lastVideo.pause();
          lastVideoBtn.classList.remove("disable_btn"); 
        }
    
        lastVideo = video;
        lastVideoBtn = videoBtn;
      } else {
   
        video.pause();
        videoBtn.classList.remove("disable_btn");
      }
    });
  });
});



// ============== size chart open and close ================

document.addEventListener("DOMContentLoaded", () => {
  const sizeChartContainer = document.querySelector('.size_popup');
  const sizeChartTrigger = document.querySelector('.cst_size_chart');
  const closeIcon = document.querySelector('.close_icon');
  const overlay = document.querySelector('.sizepopup_overlay');

  // Check if the size chart container exists before adding event listeners
  if (sizeChartContainer && sizeChartTrigger && closeIcon && overlay) {
    const toggleSizeChart = (displayStyle) => {
      sizeChartContainer.style.display = displayStyle;
    };

    const hideSizeChart = () => toggleSizeChart("none");
    const showSizeChart = () => toggleSizeChart("flex");

    sizeChartTrigger.addEventListener('click', showSizeChart);
    closeIcon.addEventListener('click', hideSizeChart);
    overlay.addEventListener('click', hideSizeChart);
  }
});


// ============== size chart open and close ================


//================== upsell pair product js on product page ======================
document.addEventListener("DOMContentLoaded", function () {
  const recommendedConn = document.querySelector("ul.recommended_add_on_container");
  const form = document.querySelector(".product-form form");

  if (!recommendedConn || !form) return;

  const mainInput = form.querySelector('input[name="items[0][id]"]');
  const mainProductId = mainInput ? mainInput.value : null;

  const selectedVariants = new Map(); // To track added inputs

  const recommendedItems = recommendedConn.querySelectorAll("li.recomended_item");

  recommendedItems.forEach((item) => {
    item.addEventListener("click", function () {
      const input = item.querySelector(".recomended_prouct_price_conn .recomended_product_id");
      if (!input) return;

      const variantId = input.value;

      if (selectedVariants.has(variantId)) {
        // Remove input if already selected
        const existingInput = selectedVariants.get(variantId);
        existingInput.remove();
        selectedVariants.delete(variantId);
        item.classList.remove("selected");
        item.setAttribute("aria-checked", "false");
      } else {
        // Add new input with next index
        const index = selectedVariants.size + 1; // +1 because 0 is for main product
        const variantInput = document.createElement("input");
        variantInput.type = "hidden";
        variantInput.name = `items[${index}][id]`;
        variantInput.value = variantId;
        variantInput.className = "product-variant-id";
        form.appendChild(variantInput);

        selectedVariants.set(variantId, variantInput);
        item.classList.add("selected");
        item.setAttribute("aria-checked", "true");
      }
    });

    item.addEventListener("keydown", function (e) {
      if (e.key === " " || e.key === "Enter") {
        e.preventDefault();
        item.click();
      }
    });
  });
});

// ================== upsell pair product js on product page ======================



// ================ add to cart Recommended product ===========================
// document.addEventListener("DOMContentLoaded", function() {
// let recommendedConn = document.querySelector('ul.recommended_add_on_container');

// if (recommendedConn) {
//   const recomenderItems = recommendedConn.querySelectorAll('li.recomended_item');
//   console.log(recomenderItems);

//   recomenderItems.forEach(function (item) {
//     item.addEventListener('click', function (event) {
//       event.preventDefault();

//       let variantInput = item.querySelector('.recomended_prouct_price_conn input.recomended_product_id');
//       let variantID = variantInput ? variantInput.value : null;

//       if (!variantID) {
//         alert('Variant ID not found.');
//         return;
//       }
//       let customdata = {
//         id: variantID,
//         quantity: 1
//       };

//       $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: customdata,
//         dataType: 'json',
//         success: function (response) {
//           // alert('Product added successfully!');
//           $('body').addClass('overflow-hidden');
          
//           setTimeout(function () {
//             $.ajax({
//               type: 'GET',
//               url: '/cart.js',
//               dataType: 'json',
//               success: function (cartItem) {
//                 let updatedQuantity = cartItem.item_count || 0;
//                 console.log(updatedQuantity, 'jiodhfioa')

//                 if ($('#cart-icon-bubble .cart-count-bubble span').length) {
//                     // Element exists, update the quantity
//                     $('#cart-icon-bubble .cart-count-bubble span').first().text(updatedQuantity);
//                 } else {
//                     // Element does not exist, create and append it
//                     var cartBubble = $('<div>', {
//                         class: 'cart-count-bubble',
//                         bis_skin_checked: '1'
//                     });

//                     var visibleSpan = $('<span>', {
//                         'aria-hidden': 'true',
//                         text: updatedQuantity
//                     });

//                     var hiddenSpan = $('<span>', {
//                         class: 'visually-hidden',
//                         text: updatedQuantity + ' item' + (updatedQuantity > 1 ? 's' : '')
//                     });

//                     cartBubble.append(visibleSpan, hiddenSpan);
//                     $('#cart-icon-bubble').append(cartBubble);
//                 }

//                 // if($('#cart-icon-bubble .cart-count-bubble span'))

//                 $('#cart-icon-bubble .cart-count-bubble span').text(updatedQuantity);
//                 $('cart-drawer').load(window.location.href + ' #CartDrawer');
//                 $('cart-drawer').removeClass('is-empty').addClass('active');
//               }
              
//             });
           
//           }, 10); 
        
//         },
//         error: function () {
//           alert('Product failed to add!');
//         }
//       });
//     });
//   });
// }
// });

// ================ add to cart Recommended product ===========================
 

